import { attachNewCardSchema, payerContactInfoSchema } from '../payerContactInfoSchema';

export const attachSubscriptionCardSchema = payerContactInfoSchema.concat(attachNewCardSchema);
